import baseURL from "@/utils/config";
import request from "@/plugins/axios"

//活动列表
export function getSearchSeeDetails(data){
  return request({
      url:`${baseURL.javaApi}/api/specialEvent/seeDetails`,
      method: "post",
      data
  });
}

// 获取合成抽奖数据
export function getSyntheticDraw(data) {
  return request({
    url: `${baseURL.api}/authapi/user/getSyntheticDraw`,
    method: "post",
    data
  });
}

// 获取活动抽奖数据
export function getActivityLottery(data) {
  return request({
    url: `${baseURL.api}/api/getActivityLottery`,
    method: "post",
    data
  });
}

// 
export function getPresentDraw(data) {
  return request({
    url: `${baseURL.api}/authapi/user/getPresentDraw`,
    method: "post",
    data
  });
}
